import { useEffect, useState } from 'react';
// Components
import { useAppDispatch } from 'app/hooks/useStore';
// Async
import { createInterimInvoice } from 'app/store/BillingInvoices/BillingInvoices.async';
import { Loader, Message } from 'app/components/Utilities';
//
import InvoiceCard from '../InvoicesTabContent/InvoiceCard';

type Props = {
  selectedCase: any;
  onSetGenerateButtonDisabled: (disabled: boolean) => void;
}

export default function DetailsStepContent({ selectedCase, onSetGenerateButtonDisabled }: Props){
  // Dispatch
  const dispatch = useAppDispatch();

  const [ loading, setLoading ] = useState(false);
  const [ billingInvoices, setBillingInvoices ] = useState<any>(null);

  useEffect(() => {
    const asyncCreateInterimInvoice = async () => {
      if ( !selectedCase ) return;
      setLoading(true);
      try {
        const data = await dispatch(createInterimInvoice({
          data: { caseId: selectedCase.id },
          params: { dryrun: true }
        })).unwrap();
        const totalAmount = (data || []).reduce((sum: number, invoice: any) => {
          return sum + (invoice.amount || 0);
        }, 0);
        onSetGenerateButtonDisabled(!data || !data.length || totalAmount === 0);
        setBillingInvoices(data);
      } catch(error){
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    asyncCreateInterimInvoice();
    // eslint-disable-next-line
  }, []);

  if ( loading ) return <Loader />;
  if ( !billingInvoices || !billingInvoices.length ) return <Message text="No invoices found for selected case" />
  return (
    <>
      {billingInvoices.map((billingInvoice:any, index:number) => (
        <InvoiceCard key={`${billingInvoice.id}-${index}`} invoice={billingInvoice} />
      ))}
    </>
  );
}
